let selectedShipFrequency = 1;
let selectedProduct = null;
let selectedSellingPlan = null;
let isGift = false;
let moneySign =
  document.querySelector('.num-received-container button')?.[0]?.dataset
    .productPrice ?? '$';

const MOST_EXPENSIVE_BOX = Number(window.fullPriceBox) || 44.99;
let leastExpensiveBox = MOST_EXPENSIVE_BOX;

const fireSrc =
  'https://cdn.shopify.com/s/files/1/0649/4388/2457/files/cropped-Flame-01-192x192.png?v=1660288756';

function convertCurrencyStringToNumber(currencyString) {
  // Remove any leading or trailing spaces:
  currencyString = currencyString.trim();

  // Use a regular expression to extract the numerical part:
  const numberMatch = currencyString.match(/^\D*(\d+(?:\.\d{2}|\,\d{2}))/);

  // If a numerical match is found, return it as a number:
  if (numberMatch) {
    return Number(numberMatch[1]);
  } else {
    // If no match is found, return NaN (Not a Number) to indicate an invalid input:
    return NaN;
  }
}

// const mostExpensiveBoxStringPrice = document.querySelector(
//   '.num-received-container button'
// ).dataset.productPrice;
// const mostExpensiveBoxQuantity = document.querySelector(
//   '.num-received-container button'
// ).dataset.numReceived;
// const MOST_EXPENSIVE_BOX =
//   convertCurrencyStringToNumber(mostExpensiveBoxStringPrice) /
//   Number(mostExpensiveBoxQuantity);

function prepaidHandleNumReceivedClick(numReceivedEl, isFirstLoad = false) {
  const numReceivedElement = isFirstLoad ? numReceivedEl : numReceivedEl.target;
  if (numReceivedElement.classList.contains('btn-selected')) return;
  const selected = document.querySelectorAll(
    '.num-received-container .btn-selected'
  );
  selected.forEach(function (element) {
    element.classList.remove('btn-selected');
  });

  selectedProduct = numReceivedElement.dataset.productId;
  selectedSellingPlan = numReceivedElement.dataset.sellingPlan;
  const productPrice = numReceivedElement.dataset.productPrice;
  const numReceived = numReceivedElement.dataset.numReceived;
  const shipFrequency = numReceivedElement.dataset.shipFrequencyProduct;
  document.querySelectorAll('.frequency-message').forEach(el => {
    el.classList.remove('d-none');
    el.classList.replace('open', 'closed');
  });

  document
    .querySelector(`[data-frequency-message-product-id="${selectedProduct}"]`)
    ?.classList.replace('closed', 'open');
  document
    .querySelectorAll('.message-shipments')
    .forEach(
      el =>
        (el.innerHTML =
          Number(numReceived) === 1 ? ' 1 box' : ` ${numReceived} boxes`)
    );
  const months = Number(numReceived) * Number(shipFrequency);
  document.querySelectorAll('.message-months').forEach(el => {
    if (Number(numReceived) === 1) {
      el.innerHTML =
        Number(shipFrequency) === 1
          ? `<b>every month</b>`
          : Number(shipFrequency) === 2
          ? `<b>every other month</b>`
          : `<b>every quarter</b>`;
    } else {
      el.innerHTML =
        months === 1 ? `over <b>1 month</b>` : `over <b>${months} months</b>`;
    }
  });

  const pricePerBox = parseFloat(
    parseFloat(productPrice.replace(moneySign, '')) / Number(numReceived)
  ).toFixed(2);

  numReceivedElement.classList.add('btn-selected');

  document.querySelector('#primary-add-to-cart').classList.remove('disabled');
  document.querySelector('#mobile-add-to-cart').classList.remove('disabled');

  document
    .querySelector('#primary-add-to-cart-gift')
    .setAttribute('data-modal-opener', `gift_modal_${selectedProduct}`);

  document
    .querySelector('#primary-add-to-cart-gift')
    .classList.remove('disabled');

  document
    .querySelector('#mobile-add-to-cart-gift')
    .setAttribute('data-modal-opener', `gift_modal_${selectedProduct}`);

  document
    .querySelector('#mobile-add-to-cart-gift')
    .classList.remove('disabled');

  const savingsPerBox = MOST_EXPENSIVE_BOX - pricePerBox;

  document
    .querySelectorAll('.total-savings-amount')
    .forEach(
      el =>
        (el.innerHTML = `${
          moneySign + Number(savingsPerBox * numReceived).toFixed(2)
        }`)
    );

  const savingsImages = document.querySelectorAll('.fire-level');
  savingsImages.forEach(function (savingsImage, index) {
    if (savingsPerBox === 0) {
      if (index > 0) {
        savingsImage.classList.remove('lit');
      } else {
        savingsImage.classList.add('lit');
      }
    } else if (savingsPerBox === 5) {
      if (index > 1) {
        savingsImage.classList.remove('lit');
      } else {
        savingsImage.classList.add('lit');
      }
    } else if (savingsPerBox === 6) {
      if (index > 2) {
        savingsImage.classList.remove('lit');
      } else {
        savingsImage.classList.add('lit');
      }
    } else if (savingsPerBox === 7) {
      if (index > 3) {
        savingsImage.classList.remove('lit');
      } else {
        savingsImage.classList.add('lit');
      }
    } else if (savingsPerBox > 7) {
      savingsImage.classList.add('lit');
    }
  });
}

function prepaidHandleShipFrequencyClick(frequencyEl, isFirstLoad = false) {
  const frequencyElement = isFirstLoad ? frequencyEl : frequencyEl.target;

  if (frequencyElement.classList.contains('btn-selected')) return;

  document.querySelectorAll('.frequency-message').forEach(el => {
    el.classList.add('d-none');
    el.classList.replace('open', 'closed');
  });
  selectedProduct = null;
  document.querySelector('#primary-add-to-cart').classList.add('disabled');
  document.querySelector('#mobile-add-to-cart').classList.add('disabled');
  document.querySelector('#primary-add-to-cart-gift').classList.add('disabled');
  document.querySelector('#mobile-add-to-cart-gift').classList.add('disabled');

  selectedShipFrequency = frequencyElement.dataset.shipFrequency;

  if (isFirstLoad) {
    hideNumReceivedSectionIfSingleOption(selectedShipFrequency);
  } else {
    const selected = document.querySelectorAll('.btn-selected');
    const numReceivedSelectedEl = document.querySelector(
      '.num-received-container .btn-selected'
    );
    if (numReceivedSelectedEl) {
      const numReceivedSelected = numReceivedSelectedEl.dataset.numReceived;

      const newNumReceivedButton = document.querySelector(
        `[data-ship-frequency-product="${selectedShipFrequency}"][data-num-received="${numReceivedSelected}"]`
      );

      if (newNumReceivedButton) {
        prepaidHandleNumReceivedClick(newNumReceivedButton, true);
      }
    }

    selected.forEach(function (element) {
      element.classList.remove('btn-selected');
    });
  }

  frequencyElement.classList.add('btn-selected');
  prepaidHideProductsByFrequency(selectedShipFrequency);
}

function hideNumReceivedSectionIfSingleOption(shipFrequency) {
  const numReceivedButtons = document.querySelectorAll(
    `[data-ship-frequency-product="${shipFrequency}"]`
  );
  if (numReceivedButtons.length === 1) {
    // if only 1 num received button is available for the selected frequency, select it
    // and hide that button section altogether.
    const numReceivedContainer = document.querySelector(
      '.num-received-container'
    );
    numReceivedContainer.classList.add('d-none');
    prepaidHandleNumReceivedClick(numReceivedButtons[0], true);
  } else {
    const numReceivedContainer = document.querySelector(
      '.num-received-container'
    );
    numReceivedContainer.classList.remove('d-none');
  }
}

function bottomRowStyling() {
  const currentTopRowSubs = document.querySelectorAll('.bottom-row-subs');
  currentTopRowSubs.forEach(subBtn =>
    subBtn.classList.remove('bottom-row-subs')
  );

  const subBtns = document.querySelectorAll(
    '.num-received-container .sub-btn:not(.d-none)'
  );
  const newTopRowSubs = Array.from(subBtns).slice(3, subBtns.length);
  newTopRowSubs.forEach(subBtn => subBtn.classList.add('bottom-row-subs'));
}

function prepaidHideProductsByFrequency(frequency) {
  const products = document.querySelectorAll('[data-ship-frequency-product]');
  products.forEach(function (product) {
    if (product.dataset.shipFrequencyProduct != frequency) {
      product.classList.add('d-none');
    } else {
      product.classList.remove('d-none');
    }
  });
  bottomRowStyling();
}

const frequencies = document.querySelectorAll('[data-ship-frequency]');
frequencies.forEach(function (frequencyEl) {
  const frequency = frequencyEl.dataset.shipFrequency;
  const frequencyPriceEls = document.querySelectorAll(
    `[data-ship-frequency-product="${frequency}"]`
  );

  Array.from(frequencyPriceEls).forEach(function (productButton, index) {
    const numReceived = productButton.dataset.numReceived;

    const frequencyPrice = (
      convertCurrencyStringToNumber(productButton.dataset.productPrice) /
      Number(numReceived)
    ).toFixed(2);

    const fireSection = frequencyPriceEls[index].querySelector('.fire-counter');

    const fires = [];
    if (fireSection) {
      for (let i = 0; i < numReceived; i++) {
        const fire = document.createElement('img');
        fire.src = fireSrc;
        fires.push(fire);
      }

      fireSection.innerHTML = '';
      fires.forEach(fire => fireSection.appendChild(fire));
    }

    if (MOST_EXPENSIVE_BOX - parseFloat(frequencyPrice) > 0) {
      const regPriceEl = frequencyPriceEls[index].querySelector('.reg-price');
      const totalRegPrice = (MOST_EXPENSIVE_BOX * Number(numReceived)).toFixed(
        2
      );
      if (regPriceEl && !regPriceEl.innerHTML) {
        regPriceEl.innerHTML = `(${moneySign + totalRegPrice})`;
      }

      const totalActualPrice = frequencyPrice * Number(numReceived);

      const savingsPerBoxEl =
        frequencyPriceEls[index].querySelector('.savings-per-box');

      if (savingsPerBoxEl) {
        savingsPerBoxEl.innerHTML = `You save ${
          moneySign + (totalRegPrice - totalActualPrice).toFixed(2)
        }`;
      }
    }

    return parseFloat(frequencyPrice);
  });

  frequencyEl.addEventListener('click', prepaidHandleShipFrequencyClick);
});

const numReceivedElements = document.querySelectorAll('[data-num-received]');
numReceivedElements.forEach(function (numReceivedEl) {
  numReceivedEl.addEventListener('click', prepaidHandleNumReceivedClick);
});

document
  .querySelector('#primary-add-to-cart')
  .addEventListener('click', async function (e) {
    await prepaidAddToCart(selectedProduct, selectedSellingPlan);
  });

document
  .querySelector('#mobile-add-to-cart')
  .addEventListener('click', async function (e) {
    await prepaidAddToCart(selectedProduct, selectedSellingPlan);
  });

document
  .querySelector('#primary-add-to-cart-gift')
  .addEventListener('click', async function (e) {
    document.querySelector(`#gift_modal_${selectedProduct}`).show(e.target);
    // await prepaidAddToCart(selectedProduct, selectedSellingPlan, true);
  });

document
  .querySelector('#mobile-add-to-cart-gift')
  .addEventListener('click', async function (e) {
    await prepaidAddToCart(selectedProduct, selectedSellingPlan, true);
  });

async function prepaidAddToCart(productId, sellingPlan = null, isGift = false) {
  const body = {
    id: productId,
    quantity: 1,
    properties: {
      _is_subscription: true,
    },
  };

  if (isGift) {
    body.properties = {
      ...body.properties,
      _is_gift: true,
    };
  }

  if (!!sellingPlan) {
    body.selling_plan = sellingPlan;
  }

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  await response.json();
}

const products = document.querySelectorAll('.num-received-container .sub-btn');
products.forEach(product => {
  const price = product.dataset.productPrice;
  const numReceived = product.dataset.numReceived;
  const pricePerBox = parseFloat(
    parseFloat(price.replace(moneySign, '')) / Number(numReceived)
  ).toFixed(2);
  leastExpensiveBox = Math.min(leastExpensiveBox, pricePerBox);
});

const leastExpensiveBoxEl = document.querySelector('#least-expensive-box');
if (leastExpensiveBoxEl) {
  leastExpensiveBoxEl.innerHTML = moneySign + leastExpensiveBox;
}

// scroll listener that fires when the user scrolls pas 1025 px
// when this happens, we want to show the mobile add to cart button
window.addEventListener('scroll', function () {
  const primaryAddToCart = document.querySelector('#primary-add-to-cart-gift');
  const mobileAddToCart = document.querySelector('#mobile-cart-btn-container');
  const primaryAddToCartRect = primaryAddToCart.getBoundingClientRect();

  if (primaryAddToCartRect.top < 1025) {
    const btnSelected = document.querySelector(
      '.num-received-container .btn-selected'
    );
    if (btnSelected) {
      mobileAddToCart.classList.add('slide-in-view');
    }
  } else {
    mobileAddToCart.classList.remove('slide-in-view');
  }
});

//----- removed default product selection per Peter's request

// const defaultProduct = document.querySelector(`[data-default-product="true"]`);

// if (defaultProduct) {
//   const defaultShipFrequency = Number(
//     defaultProduct.dataset.shipFrequencyProduct
//   );
//   const defaultShipFrequencyEl = document.querySelector(
//     `[data-ship-frequency="${defaultShipFrequency}"]`
//   );
//   if (defaultShipFrequencyEl) {
//     prepaidHandleShipFrequencyClick(defaultShipFrequencyEl, true);
//     prepaidHandleNumReceivedClick(defaultProduct, true);
//   }
// } else {
// default to first visible delivery schedule (DOM order)
const firstShipFrequencyEl = document.querySelector('[data-ship-frequency]');
if (firstShipFrequencyEl) {
  prepaidHandleShipFrequencyClick(firstShipFrequencyEl, true);
}
// }
